<template>
    <div class="echart" :id="id"></div>
</template>
<script>
import axios from 'axios';
export default {
    name:'mapChart',
    data(){
         return {
            chart:'',
            provinces : {
                '上海': 'shanghai',
                '河北': 'hebei',
                '山西': 'shanxi',
                '内蒙古': 'neimenggu',
                '辽宁': 'liaoning',
                '吉林': 'jilin',
                '黑龙江': 'heilongjiang',
                '江苏': 'jiangsu',
                '浙江': 'zhejiang',
                '安徽': 'anhui',
                '福建': 'fujian',
                '江西': 'jiangxi',
                '山东': 'shandong',
                '河南': 'henan',
                '湖北': 'hubei',
                '湖南': 'hunan',
                '广东': 'guangdong',
                '广西': 'guangxi',
                '海南': 'hainan',
                '四川': 'sichuan',
                '贵州': 'guizhou',
                '云南': 'yunnan',
                '西藏': 'xizang',
                '陕西': 'shanxi1',
                '甘肃': 'gansu',
                '青海': 'qinghai',
                '宁夏': 'ningxia',
                '新疆': 'xinjiang',
                '北京': 'beijing',
                '天津': 'tianjin',
                '重庆': 'chongqing',
                '香港': 'xianggang',
                '澳门': 'aomen',
                '台湾': 'taiwan'
            }
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        optionName:{
            type: String 
        },
        areaName: { 
            type: String,
            default:'全国' 
        },
        isShow: { 
            type: Boolean,
            default:true
        },
   
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        dataArray () {
            this.init();
        }
    },
    methods: {
        mapOption(name){
            let data = this.dataArray;
            let option = {
                tooltip: {
                    show: this.isShow,
                    formatter: function(params) {
                        let newParams='';
                        if(params.data){
                            newParams = params.name + '：' + params.data['value']
                        }
                        return newParams;
                    },
                },
                visualMap: {
                    show:this.isShow,
                    type: 'continuous',
                    text: ['高', '低'],
                    showLabel: true,
                    left: '-5',
                    itemWidth: 20,
                    itemHeight: 60,
                    min: 0,
                    max: data[0].value,
                    inRange: {
                        color: ['#b2e6ff', '#126ad9']
                    },
                    splitNumber: 0,
                    calculable: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                series: [{
                    name: 'MAP',
                    zoom:1.1,
                    type: 'map',
                    mapType: name,
                    //selectedMode: 'false',//是否允许选中多个区域
                    label: {
                        normal: {
                            show: false,
                        
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#ccc',
                            borderWidth: 1,
                            borderColor: '#d4e8fb',
                            
                        }
                    },
                    data: data
                }]
            };
            return option;
        },
        loadMap(mapCode, name,isCall) {
            let _this = this; 
            _this.$axios.get(mapCode).then(res=>{
                _this.$echarts.registerMap(name, res.data);
                _this.chart.setOption(_this.mapOption(name));                
            }).catch(error =>{
            //   console.log(error);
            });
        },
        init(){
            let _this = this, timeFn = null;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            if(_this.areaName=="全国"){
                _this.loadMap(_this.$parent.$parent.baseUrl+'/static/json/china.json', 'china');
            }else{
                _this.loadMap(_this.$parent.$parent.baseUrl+'/static/json/province/'+_this.provinces[_this.areaName]+'.json', _this.areaName);
            }
            _this.chart.on('click', function(params) {
                clearTimeout(timeFn);
                //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
                timeFn = setTimeout(function() {
                    let name = params.name; //地区name
                    let mapCode = _this.provinces[name]; //地区的json数据
                    if (!mapCode) {
                        //alert('无此区域地图显示');
                        return;
                    }
                   // _this.loadMap(mapCode, name);
                    _this.$parent.fatherMethod(name,_this.id);
                }, 250);
            });
            // 绑定双击事件，返回全国地图
            _this.chart.on('dblclick', function(params) {
                //当双击事件发生时，清除单击事件，仅响应双击事件
                clearTimeout(timeFn);
                //返回全国地图
                _this.$parent.fatherMethod("全国",_this.id);
                // _this.loadMap('/echarts/china', 'china');
            });
           window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/mapChart.vue